import React from 'react';
import PropTypes from 'prop-types';
import { UploadedPhoto } from '../../prop-types';
import { QuantityInput } from '../glass/quantity-input';
import Button from '../../../_common/button';
import { builderDispatch } from '../../../_utils/ui';
import { UpdatePhotoEvents } from '../../common/events/event-declarations';

export default function SideMenu({ photo, handleResizeOptionsModal }) {
  const update = (value, photo, key) => {
    builderDispatch.dispatch({
      type: UpdatePhotoEvents.UPDATE,
      photo: {
        ...photo,
        [key]: value,
      },
      hard: true,
    });
  };

  const handleQuantityChange = (e, photo) => {
    const value = parseInt(e.target.value, 10);
    return update(value, photo, 'quantity');
  };

  const { quantity, image_id: imageId, size } = photo;

  return (
    <>
      <QuantityInput
        key={`${imageId}-${quantity}`}
        value={quantity}
        onQuantityChange={value =>
          handleQuantityChange({ target: { value } }, photo)
        }
        hideLabel
      />
      <Button
        className="list-view-mobile__resize-btn"
        onClick={handleResizeOptionsModal}>
        Change Size
        <p className="list-view-mobile__change-size-text">{size.title}</p>
      </Button>
    </>
  );
}

SideMenu.propTypes = {
  photo: UploadedPhoto.isRequired,
  handleResizeOptionsModal: PropTypes.func.isRequired,
};
